import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import state from './state'
import {PASSPORTALLSTORE} from '~common/commonModule/passport/vuex/index.js'
Vue.use(Vuex)
let modules = {}
modules = Object.assign(modules, PASSPORTALLSTORE)
export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: modules
})



// WEBPACK FOOTER //
// ./module/passport/src/store/index.js